import { useAppSelector } from 'app/state'
import { BuilderMode } from '../types'

function useBuilderMode() {
  const builderMode = useAppSelector((state) => state.builder.builderMode)
  const previewMode = useAppSelector((state) => state.builder.previewMode)

  const isPublicMode = builderMode === BuilderMode.Public
  const isViewerMode = builderMode === BuilderMode.Viewer
  const isEditorMode = builderMode === BuilderMode.Editor
  const isPreviewMode = previewMode
  const shouldSaveMap = isEditorMode || isPreviewMode

  return {
    isViewerMode,
    isPublicMode,
    isSharedMode: isPublicMode || isViewerMode,
    isEditorMode,
    isPreviewMode,
    shouldSaveMap,
    /// @deprecated
    isPublicMapLocation: isPublicMode, // TODO: remove
    isViewerMapLocation: isViewerMode, // TODO: remove
    isSharedMapLocation: isPublicMode || isViewerMode // TODO: remove,
  }
}

export default useBuilderMode
